import _inherits from "/node_modules/next/dist/compiled/@babel/runtime/helpers/esm/inherits.js";
import _setPrototypeOf from "/node_modules/next/dist/compiled/@babel/runtime/helpers/esm/setPrototypeOf.js";
function _wrapRegExp() { _wrapRegExp = function _wrapRegExp(re, groups) { return new BabelRegExp(re, void 0, groups); }; var _super = RegExp.prototype, _groups = new WeakMap(); function BabelRegExp(re, flags, groups) { var _this = new RegExp(re, flags); return _groups.set(_this, groups || _groups.get(re)), _setPrototypeOf(_this, BabelRegExp.prototype); } function buildGroups(result, re) { var g = _groups.get(re); return Object.keys(g).reduce(function (groups, name) { var i = g[name]; if ("number" == typeof i) groups[name] = result[i];else { for (var k = 0; void 0 === result[i[k]] && k + 1 < i.length;) { k++; } groups[name] = result[i[k]]; } return groups; }, Object.create(null)); } return _inherits(BabelRegExp, RegExp), BabelRegExp.prototype.exec = function (str) { var result = _super.exec.call(this, str); if (result) { result.groups = buildGroups(result, this); var indices = result.indices; indices && (indices.groups = buildGroups(indices, this)); } return result; }, BabelRegExp.prototype[Symbol.replace] = function (str, substitution) { if ("string" == typeof substitution) { var groups = _groups.get(this); return _super[Symbol.replace].call(this, str, substitution.replace(/\$<([^>]+)>/g, function (_, name) { var group = groups[name]; return "$" + (Array.isArray(group) ? group.join("$") : group); })); } if ("function" == typeof substitution) { var _this = this; return _super[Symbol.replace].call(this, str, function () { var args = arguments; return "object" != typeof args[args.length - 1] && (args = [].slice.call(args)).push(buildGroups(args, _this)), substitution.apply(this, args); }); } return _super[Symbol.replace].call(this, str, substitution); }, _wrapRegExp.apply(this, arguments); }
import { useContext } from 'react';
/* eslint-disable no-console */
import { documentToHtmlString } from '@contentful/rich-text-html-renderer';
// import { parsePhoneNumberFromString } from 'libphonenumber-js';
// import slugify from 'url-slug';
import urlSlug from 'url-slug';
import { Context } from '../global-state-context';
import constants, { BROWSER, imageOptimisation, linkTargetWindow, mediaContentType, THEME_CONST } from '../constants/globalConstants';
import { globalLabels, locationLabels } from '../constants/labels/en';
import breakPoints from '../themes/breakpoints';
import textures from '../themes/textures';
import fontColor from '../constants/globalConstants';
import { DateTime, Interval } from 'luxon';
import { convertToRgba } from './dynamicStyles';

// function to convert phones to national format;
export var convertPhoneFormat = function convertPhoneFormat(phone) {
  var intParse = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : true;
  var useGoogleFormat = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : true;
  var num = intParse ? parseInt(phone) : phone;

  //Filter only numbers from the input
  var cleaned = ('' + num).replace(/\D/g, '');

  //Check if the input is of correct
  var match = cleaned.match(/^(1|)?(\d{3})(\d{3})(\d{4})$/);
  if (match) {
    //Remove the matched extension code
    //Change this to format for any country code.
    var intlCode = match[1] ? '1 ' : '';
    return useGoogleFormat ? "(".concat(match[2], ") ").concat(match[3], "-").concat(match[4]) : [intlCode, match[2], '-', match[3], '-', match[4]].join('');
  }
  return null;
};
/** Function to get hours in 12 hour format
 * parameters : hour - in 24 hour format, minutes
 * data in array
 * returns - hour in 12 hour format with meridian string
 */
var getHourOfDay = function getHourOfDay(hour, minute) {
  var h = hour % 12 || 12;
  var ampm = hour < 12 ? globalLabels.meridian.am : globalLabels.meridian.pm;
  var timeString = h + ':' + minute + ampm;
  return timeString;
};
var is24Hour = function is24Hour(perDayHoursArray) {
  return parseInt(perDayHoursArray[0]) === 0 && parseInt(perDayHoursArray[1]) === 0 && parseInt(perDayHoursArray[2]) === 0 && parseInt(perDayHoursArray[3]) === 0 || parseInt(perDayHoursArray[0]) === 0 && parseInt(perDayHoursArray[1]) === 0 && perDayHoursArray[2] === '23' && perDayHoursArray[3] === '59';
};
/** Function to get hours string
 * parameters : perDayHoursArray - working hours fetched from Yext
 * data in array
 * returns - hour string for users
 */
var getHourString = function getHourString(perDayHoursArray) {
  var perDayHoursString = '';
  if (is24Hour(perDayHoursArray)) {
    perDayHoursString += locationLabels.open24hours;
  }
  // check if daily hours has split hours
  else if (perDayHoursArray.length > 4) {
    var from = parseInt(perDayHoursArray[0]);
    var to = parseInt(perDayHoursArray[2]);
    var splitFrom = parseInt(perDayHoursArray[4]);
    var splitTo = parseInt(perDayHoursArray[6]);
    perDayHoursString += getHourOfDay(from, perDayHoursArray[1]);
    perDayHoursString += " - ".concat(getHourOfDay(to, perDayHoursArray[3]));
    perDayHoursString += " - ".concat(getHourOfDay(splitFrom, perDayHoursArray[5]));
    perDayHoursString += " - ".concat(getHourOfDay(splitTo, perDayHoursArray[7]));
  } else {
    var _from = parseInt(perDayHoursArray[0]);
    var _to = parseInt(perDayHoursArray[2]);
    perDayHoursString += getHourOfDay(_from, perDayHoursArray[1]);
    perDayHoursString += " - ".concat(getHourOfDay(_to, perDayHoursArray[3]));
  }
  return perDayHoursString;
};

/** Function to parse the Working Hours and Extended Hours
 * parameters : perDayHoursArray - working hours fetched from Yext
 * data in array
 * returns - hour string for users
 */
export var parseWorkingHours = function parseWorkingHours(hours, extendedHoursString) {
  // converting hours and parsing string
  var gettingParseHoursAndDays = function gettingParseHoursAndDays(origin, dest) {
    var defaultString = locationLabels.closed;
    return origin.map(function (info) {
      if (info.openIntervals) {
        var splitDay = [];
        info.openIntervals.map(function (item) {
          var hoursArray = [item.start, item.end];
          var formatHours = hoursArray.join().replace(',', ':').split(':');

          // check if 'Open Intervals' has 'split hours'
          if (info.openIntervals.length > 1) {
            splitDay.push(formatHours);
            var splitHoursArray = splitDay.join().split(',');
            if (splitHoursArray.length > 5) {
              var splitHour = getHourString(splitHoursArray);
              dest.push(splitHour);
            }
          }
          // check if 'Open Intervals' is open
          else {
            var convertedHours = getHourString(formatHours);
            dest.push(convertedHours);
          }
        });
      }
      // check if 'Is Closed'
      else if (info.isClosed) {
        dest.push(defaultString);
      }
    });
  };
  var perDayHoursDetailArray = [],
    arrayNameOfDay = [],
    nameOfDay = [],
    extendedHoursDetailArray = [],
    extendedHours = extendedHoursString ? true : false;

  // function to generates our arrays (perDayHoursDetailArray, extendedHoursDetailArray)
  var createDaysAndHoursArray = function createDaysAndHoursArray(data, dest) {
    if (data) {
      Object.entries(data).map(function (origin) {
        if (origin[0] == 'holidayHours') return; // remove holiday hours
        // creates the array with name of the days
        var day = origin[0];
        var singleDay = day.charAt(0).toUpperCase() + day.slice(1).slice(0, 2);
        arrayNameOfDay.push(singleDay);
        // creates the array converting days and hours formatted;
        gettingParseHoursAndDays(origin, dest);
      });
    }
  };

  // calling the function to create the array
  createDaysAndHoursArray(hours, perDayHoursDetailArray);
  extendedHours && createDaysAndHoursArray(extendedHoursString, extendedHoursDetailArray);

  // remove duplicates entries
  nameOfDay = Array.from(new Set(arrayNameOfDay));
  return {
    extendedHours: extendedHours,
    perDayHoursDetailArray: perDayHoursDetailArray,
    extendedHoursDetailArray: extendedHoursDetailArray,
    nameOfDay: nameOfDay
  };
};

/** Function to get hours string
 * parameters : addressString - address in string format
 * returns - google Map URL of location
 */
export var getAddressURL = function getAddressURL(addressString) {
  return "".concat(constants.API.googleMap.url).concat(encodeURI(addressString));
};
/** Function to get complete adress
 * parameters : address - address in string format
 * address2 - address2 in string format
 * city - city in string format
 * state - state in string format
 * zip - zip in string format
 * returns - google Map URL of location
 */

export var getCompleteAddress = function getCompleteAddress(address, address2, city, state, zip) {
  var addressString = "".concat(address ? address + ', ' : '').concat(address2 && address2 !== 'undefined' ? '\n' + address2 + ', ' : '', "\n").concat(city ? city + ', ' : '', "\n").concat(state ? state + ', ' : '', "\n").concat(zip ? zip : '');
  return addressString;
};

/** Funtion to get property in a response
 * parameters : response and property
 * returns - values of that property in response
 */
export var fetchProperty = function fetchProperty(response, property, arrayIndex) {
  if (arrayIndex) return response && response[property] && response[property][arrayIndex] ? response[property][arrayIndex] : '';else return response && response[property] && response[property] !== 'undefined' ? response[property] : '';
};

/** Funtion to retrieve api key for google static maps
 * parameters : n/a
 * returns - api key
 */
export var getGoogleStaticMapsApiKey = function getGoogleStaticMapsApiKey() {
  return process.env.NEXT_PUBLIC_GOOGLE_STATIC_MAPS_API_KEY;
};

/**
 *
 * @param {string} time
 * e.g. input 3:30pm, output: 15:30:00
 * does not handle seconds as of now to convert as not needed
 * time string is expected as hh:mm or 'open 24 hours'
 * will need modification in order to cater to seconds
 */

export var timeConvertor = function timeConvertor(time) {
  if (!time) return;
  if (time.toLowerCase() === 'open 24 hrs') return time;
  var isPM = time.match('pm') ? true : false;
  time = time.split(':');
  var min = '';
  var hour = '';
  if (isPM) {
    hour = 12 + parseInt(time[0], 10);
    min = time[1] && time[1].trim().replace('pm', '');
  } else {
    hour = time[0];
    min = time[1] && time[1].trim().replace('am', '');
  }
  return "".concat(hour, ":").concat(min, ":00");
};

/** Funtion to get property in a response with hyphen
 * parameters : phone numbers
 * returns - returns phone number in xxx-xxx-xxxx format
 */
export var formatPhoneNumberHyphen = function formatPhoneNumberHyphen(phoneNumberString) {
  var cleaned = ('' + phoneNumberString).replace(/\D/g, '');
  var match = cleaned.match(/^(\d{3})(\d{3})(\d{4})$/);
  if (match) {
    return '' + match[1] + '-' + match[2] + '-' + match[3];
  }
  return null;
};

/** Funtion to get property in a response with hyphen
 * parameters : phone numbers
 * returns - returns phone number in xxx-xxx-xxxx format
 */
export var formatPhoneNumberAria = function formatPhoneNumberAria(phoneNumberString) {
  var cleaned = ('' + phoneNumberString).replace(/\D/g, '');
  var match = cleaned.match(/^(\d{3})(\d{3})(\d{4})$/);
  if (match) {
    return '' + match[1].split('').toString().replace(/,/g, ' ') + '. ' + match[2].split('').toString().replace(/,/g, ' ') + '. ' + match[3].split('').toString().replace(/,/g, ' ');
  }
  return null;
};

/** Funtion to get property in a response
 * returns - returns date in yyyy format
 */
export var getYear = function getYear() {
  var dt = new Date();
  return dt.getFullYear();
};
export var getOpenHoursMessage = function getOpenHoursMessage(workingHours, extendedHours) {
  if (!workingHours) return;
  var currentDate = DateTime.now();
  var nextDate = currentDate.plus({
    days: 1
  });
  var currentWorkingHours = workingHours[currentDate.weekdayLong.toLowerCase()];
  var extendedWorkingHours = extendedHours === null || extendedHours === void 0 ? void 0 : extendedHours[currentDate.weekdayLong.toLowerCase()];
  var nextDateWorkingHours = workingHours[nextDate.weekdayLong.toLowerCase()];
  if (currentWorkingHours.isClosed && !extendedWorkingHours || currentWorkingHours.isClosed && extendedWorkingHours !== null && extendedWorkingHours !== void 0 && extendedWorkingHours.isClosed) {
    return getWorkingHoursMessage({
      isClosed: true
    });
  }
  if (currentWorkingHours !== null && currentWorkingHours !== void 0 && currentWorkingHours.openIntervals) {
    var firstWorkingHoursStart;
    var firstWorkingHoursEnd;
    var secondWorkingHoursStart;
    var secondWorkingHoursEnd;
    currentWorkingHours.openIntervals.forEach(function (currentWorkingHour) {
      var workingHoursStart = DateTime.fromISO(currentWorkingHour.start);
      var workingHoursEnd = DateTime.fromISO(currentWorkingHour.end);
      if (!firstWorkingHoursStart) {
        firstWorkingHoursStart = workingHoursStart;
        firstWorkingHoursEnd = workingHoursEnd;
      } else {
        secondWorkingHoursStart = workingHoursStart;
        secondWorkingHoursEnd = workingHoursEnd;
      }
    });
    if (extendedWorkingHours !== null && extendedWorkingHours !== void 0 && extendedWorkingHours.openIntervals) {
      var firstExtendedWorkingHoursStart;
      var firstExtendedWorkingHoursEnd;
      var secondExtendedWorkingHoursStart;
      var secondExtendedWorkingHoursEnd;
      extendedWorkingHours.openIntervals.forEach(function (extendedWorkingHour) {
        var workingHoursStart = DateTime.fromISO(extendedWorkingHour.start);
        var workingHoursEnd = DateTime.fromISO(extendedWorkingHour.end);
        if (!firstExtendedWorkingHoursStart) {
          firstExtendedWorkingHoursStart = workingHoursStart;
          firstExtendedWorkingHoursEnd = workingHoursEnd;
        } else {
          secondExtendedWorkingHoursStart = workingHoursStart;
          secondExtendedWorkingHoursEnd = workingHoursEnd;
        }
      });
      return getWorkingHoursMessage({
        currentDate: currentDate,
        firstWorkingHoursStart: firstWorkingHoursStart,
        firstWorkingHoursEnd: firstWorkingHoursEnd,
        secondWorkingHoursStart: secondWorkingHoursStart,
        secondWorkingHoursEnd: secondWorkingHoursEnd,
        firstExtendedWorkingHoursStart: firstExtendedWorkingHoursStart,
        firstExtendedWorkingHoursEnd: firstExtendedWorkingHoursEnd,
        secondExtendedWorkingHoursStart: secondExtendedWorkingHoursStart,
        secondExtendedWorkingHoursEnd: secondExtendedWorkingHoursEnd,
        nextDateWorkingHours: nextDateWorkingHours
      });
    }
    return getWorkingHoursMessage({
      currentDate: currentDate,
      firstWorkingHoursStart: firstWorkingHoursStart,
      firstWorkingHoursEnd: firstWorkingHoursEnd,
      secondWorkingHoursStart: secondWorkingHoursStart,
      secondWorkingHoursEnd: secondWorkingHoursEnd,
      nextDateWorkingHours: nextDateWorkingHours
    });
  }
  return getWorkingHoursMessage({
    currentDate: currentDate,
    workingHoursEnd: currentDate.minus({
      hours: 1
    }),
    nextDateWorkingHours: nextDateWorkingHours
  });
};
var getWorkingHoursMessage = function getWorkingHoursMessage(_ref) {
  var currentDate = _ref.currentDate,
    firstWorkingHoursStart = _ref.firstWorkingHoursStart,
    firstWorkingHoursEnd = _ref.firstWorkingHoursEnd,
    secondWorkingHoursStart = _ref.secondWorkingHoursStart,
    secondWorkingHoursEnd = _ref.secondWorkingHoursEnd,
    firstExtendedWorkingHoursStart = _ref.firstExtendedWorkingHoursStart,
    firstExtendedWorkingHoursEnd = _ref.firstExtendedWorkingHoursEnd,
    secondExtendedWorkingHoursStart = _ref.secondExtendedWorkingHoursStart,
    secondExtendedWorkingHoursEnd = _ref.secondExtendedWorkingHoursEnd,
    nextDateWorkingHours = _ref.nextDateWorkingHours,
    isClosed = _ref.isClosed;
  if (!isClosed) {
    var firstWorkingInterval = firstWorkingHoursStart && firstWorkingHoursEnd ? Interval.fromDateTimes(firstWorkingHoursStart, firstWorkingHoursEnd) : null;
    var secondWorkingInterval = secondWorkingHoursStart && secondWorkingHoursEnd ? Interval.fromDateTimes(secondWorkingHoursStart, secondWorkingHoursEnd) : null;
    var firstExtendedWorkingInterval = firstExtendedWorkingHoursStart && firstExtendedWorkingHoursEnd ? Interval.fromDateTimes(firstExtendedWorkingHoursStart, firstExtendedWorkingHoursEnd) : null;
    var secondExtendedWorkingInterval = secondExtendedWorkingHoursStart && secondExtendedWorkingHoursEnd ? Interval.fromDateTimes(secondExtendedWorkingHoursStart, secondExtendedWorkingHoursEnd) : null;

    // Normal scenario
    if (firstWorkingInterval !== null && firstWorkingInterval !== void 0 && firstWorkingInterval.contains(currentDate)) {
      if ((firstWorkingHoursEnd === null || firstWorkingHoursEnd === void 0 ? void 0 : firstWorkingHoursEnd.toMillis()) == (firstExtendedWorkingHoursStart === null || firstExtendedWorkingHoursStart === void 0 ? void 0 : firstExtendedWorkingHoursStart.toMillis())) {
        return "Open Now until ".concat(firstExtendedWorkingHoursEnd.toFormat('t'));
      }
      return "Open Now until ".concat(firstWorkingHoursEnd.toFormat('t'));
    }

    // Split scenario
    else if (secondWorkingInterval !== null && secondWorkingInterval !== void 0 && secondWorkingInterval.contains(currentDate)) {
      if ((secondWorkingHoursEnd === null || secondWorkingHoursEnd === void 0 ? void 0 : secondWorkingHoursEnd.toMillis()) == (firstExtendedWorkingHoursStart === null || firstExtendedWorkingHoursStart === void 0 ? void 0 : firstExtendedWorkingHoursStart.toMillis())) {
        return "Open Now until ".concat(firstExtendedWorkingHoursEnd.toFormat('t'));
      }
      return "Open Now until ".concat(secondWorkingHoursEnd.toFormat('t'));
    }

    // Extended Hours scenario
    if (firstExtendedWorkingInterval !== null && firstExtendedWorkingInterval !== void 0 && firstExtendedWorkingInterval.contains(currentDate)) {
      return "Open Now until ".concat(firstExtendedWorkingHoursEnd.toFormat('t'));
    }

    // Split Extended Hours scenario
    else if (secondExtendedWorkingInterval !== null && secondExtendedWorkingInterval !== void 0 && secondExtendedWorkingInterval.contains(currentDate)) {
      return "Open Now until ".concat(secondExtendedWorkingHoursEnd.toFormat('t'));
    }

    // Closed now but opens today
    if (currentDate < firstWorkingHoursStart) {
      return "Opens at ".concat(DateTime.fromISO(firstWorkingHoursStart).toFormat('t'));
    }
    if (secondWorkingHoursStart && currentDate >= firstWorkingHoursEnd && currentDate < secondWorkingHoursStart) {
      return "Opens at ".concat(DateTime.fromISO(secondWorkingHoursStart).toFormat('t'));
    }

    // Closed now but opens at extended hours
    if (currentDate < firstExtendedWorkingHoursStart) {
      return "Opens at ".concat(DateTime.fromISO(firstExtendedWorkingHoursStart).toFormat('t'));
    }
    if (secondExtendedWorkingHoursStart && currentDate >= firstExtendedWorkingHoursEnd && currentDate < secondExtendedWorkingHoursStart) {
      return "Opens at ".concat(DateTime.fromISO(secondExtendedWorkingHoursStart).toFormat('t'));
    }

    // Closed now, opens tomorrow
    if (nextDateWorkingHours.openIntervals) {
      return "Opens at ".concat(DateTime.fromISO(nextDateWorkingHours.openIntervals[0].start).toFormat('t'), " tomorrow");
    }
  }

  // Closed Today all day or working hours ended and closed tomorrow
  return 'Closed Today';
};

/** Funtion to trim text
 * parameters : text - text to be trimmed
 * parameters : charLimit - limit of characters
 * returns : trimmed text
 */
export var trimText = function trimText(text, charLimit) {
  var myText = text;
  if (myText && myText.length > charLimit) {
    myText = myText.substring(0, charLimit);
  }
  return myText;
};

/** Funtion to get backgroundcolor Class name
 * parameters : data - to fetch backgroundcolor
 * returns : class name
 */
export var getBackgroundColorClass = function getBackgroundColorClass(data) {
  return data ? data.toLowerCase() + '-bg-color' : '';
};

/** Funtion to get target window
 * parameters : behavior - string
 * returns : returns value like _blank or _self
 */
export var getTargetWindow = function getTargetWindow(behavior) {
  return behavior && behavior === linkTargetWindow.newWindow ? '_blank' : '_self';
};

/**
 * Proxy for 'url-slug' module
 * // TODO: Refactor all occurrances to use the module
 * @param {String} phrase to convert to a URL or ID-safe slug
 */

export var createLinkID = function createLinkID(phrase) {
  return phrase ? urlSlug(phrase) : '';
};

/**
 * Strip # from start =
 * @param {String} phrase to strip # from the start
 */

export var stripHashfromStart = function stripHashfromStart(phrase) {
  return phrase ? phrase.trim().replace(/^#/, '') : '';
};

/** Funtion to set setSessionStorage
 * parameters : key - key name of the sessionstorage
 * parameters : value - value of the key in sessionstorage
 * returns : null
 */
export var setSessionStorage = function setSessionStorage(key, value) {
  typeof window !== 'undefined' && window.sessionStorage.setItem(key, value);
};
/** Funtion to check is refereer is present
 * returns : boolean
 */
export var getReferrer = function getReferrer(key, value) {
  if (typeof window !== 'undefined' && window.document && window.document.referrer) {
    return true;
  }
  return false;
};
/** Funtion to set setSessionStorage
 * parameters : key - key name of the sessionstorage
 * returns : value for session storage
 */
export var getSessionStorage = function getSessionStorage(key) {
  return typeof window !== 'undefined' && window.sessionStorage.getItem(key);
};

/** Function to fetch tile Image and Video tiles data for ImageGallery Component
Parameters:
  tileData - Array or media
  mediaType - Type of Media
Return: Gallery Tile Object
*/
var fetchGalleryTileFromArray = function fetchGalleryTileFromArray(tileData, mediaType) {
  var _tileData$thumbnail, _tileData$thumbnail2;
  var appliedClass = mediaType === mediaContentType.IMAGE ? 'gallery-media' : 'gallery-media video-play';
  var fileType = mediaType === mediaContentType.IMAGE ? 'image' : 'video';
  var imgSrc = mediaType === mediaContentType.IMAGE ? tileData.image.url : tileData.thumbnail.mobileImage && tileData.thumbnail.mobileImage.url || tileData.thumbnail.image.url;
  if (!imgSrc) {
    imgSrc = mediaType === mediaContentType.IMAGE ? tileData.image.file.url : tileData.thumbnail.mobileImage.file.url;
  }
  var title = mediaType === mediaContentType.IMAGE ? tileData.title || tileData.altText : ((_tileData$thumbnail = tileData.thumbnail) === null || _tileData$thumbnail === void 0 ? void 0 : _tileData$thumbnail.title) || ((_tileData$thumbnail2 = tileData.thumbnail) === null || _tileData$thumbnail2 === void 0 ? void 0 : _tileData$thumbnail2.altText) || tileData.title;
  var altText = mediaContentType.IMAGE ? tileData.altText : tileData.thumbnail.altText;
  var modalUrl = mediaType === mediaContentType.IMAGE ? tileData.image.url ? tileData.image.url : tileData.image.file.url : tileData.url;
  var imageCaption = mediaType === mediaContentType.IMAGE ? tileData.imageCaption : tileData.thumbnail.imageCaption;
  var attribution = mediaType === mediaContentType.IMAGE ? tileData.attribution : tileData.thumbnail.attribution;
  return {
    appliedClass: appliedClass,
    imgSrc: imgSrc,
    altText: altText,
    title: title,
    modalUrl: modalUrl,
    mediaType: mediaType,
    fileType: fileType,
    imageCaption: imageCaption,
    attribution: attribution
  };
};

/** Function to fetch tile Image and Video tiles data for ImageGallery Component
Parameters:
  galleryData - gallery data object
Return: Array of Gallery Tiles
*/
export var parseGalleryJSON = function parseGalleryJSON(galleryData) {
  var imageTiles = galleryData && galleryData.tileCollection && galleryData.tileCollection.items && galleryData.tileCollection.items.length ? galleryData.tileCollection.items : [];
  if (!imageTiles || imageTiles.length === 0) {
    imageTiles = galleryData && galleryData.tile && galleryData.tile.length ? galleryData.tile : [];
  }
  var videoTiles = galleryData && galleryData.videoTileCollection && galleryData.videoTileCollection.items && galleryData.videoTileCollection.items.length ? galleryData.videoTileCollection.items : [];
  if (!videoTiles || videoTiles.length === 0) {
    videoTiles = galleryData && galleryData.videoTile && galleryData.videoTile.length ? galleryData.videoTile : [];
  }
  var galleryImageTileArray = imageTiles.map(function (tileData, index) {
    return fetchGalleryTileFromArray(tileData, mediaContentType.IMAGE);
  });
  var galleryVideoTileArray = videoTiles.map(function (tileData, index) {
    return fetchGalleryTileFromArray(tileData, mediaContentType.VIDEO);
  });
  return galleryImageTileArray.concat(galleryVideoTileArray);
};

/** Function tocheck object
Return: true for object
*/
export var isObject = function isObject(a) {
  return !!a && a.constructor === Object;
};

/** Function to check array
Return: true for array
*/
export var isArray = function isArray(a) {
  return !!a && a.constructor === Array;
};

/** Funtion to parse rich text content
 * parameters : content
 * returns - html
 * TODO: https://www.contentful.com/developers/docs/tutorials/general/getting-started-with-rich-text-field-type/
 */
export var parseRichText = function parseRichText(jsonContent) {
  var isHero = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : false;
  var removeEmptyParagraph = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : true;
  try {
    var contentParsed = jsonContent && typeof jsonContent === 'string' ? JSON.parse(jsonContent) : jsonContent;
    var htmlContent = contentParsed && isHero ? removeEmptyParagraph ? documentToHtmlString(contentParsed).replace(/\n/g, "<br/>").split('<p></p>').join('') : documentToHtmlString(contentParsed).replace(/\n/g, "<br/>") : removeEmptyParagraph ? documentToHtmlString(contentParsed).replace(/\n/g, "").split('<p></p>').join('') : documentToHtmlString(contentParsed).replace(/\n/g, "");
    return htmlContent;
  } catch (e) {
    return '';
  }
};

/** Funtion convert string in lower case
 * parameters : string
 * returns - string
 */
export var toLower = function toLower(stringData) {
  try {
    return stringData.toLowerCase();
  } catch (e) {
    return '';
  }
};

/** Funtion GTM
 */
export var GTMsrc = function GTMsrc(src, gtmId) {
  try {
    return "(function(w,d,s,l,i){w[l]=w[l]||[];w[l].push({'gtm.start':\n                      new Date().getTime(),event:'gtm.js'});var f=d.getElementsByTagName(s)[0],\n                      j=d.createElement(s),dl=l!='dataLayer'?'&l='+l:'';j.async=true;j.src=\n                      '".concat(src, "?id='+i+dl;f.parentNode.insertBefore(j,f);\n                      })(window,document,'script','dataLayer','").concat(gtmId, "');");
  } catch (e) {
    return '';
  }
};

/** Funtion to get website language (two characters)
 * parameters : string
 * parameters : string
 * returns - string
 */
export var getLanguageAndLocation = function getLanguageAndLocation(stringData, type) {
  try {
    var data = type === 'loc' ? stringData.split('-')[1] : stringData.split('-')[0];
    return toLower(data);
  } catch (e) {
    return '';
  }
};

/** Funtion to get configured social media icons
 * parameters : string
 * returns - string
 */
export var getSocialForAnalytics = function getSocialForAnalytics(socialLinksObj) {
  if (socialLinksObj) {
    try {
      var returnSocial = [];
      for (var prop in socialLinksObj) {
        if (socialLinksObj[prop] !== '') {
          returnSocial.push(toLower(prop.replace('Url', '')));
        }
      }
      return returnSocial.toString();
    } catch (e) {
      return '';
    }
  }
  return '';
};
/** Funtion to show the promotion tile
 * parameters :startDate : string, endDate : string
 * returns - boolean
 */
export var showPromoTile = function showPromoTile(startDate, endDate) {
  if (startDate == null || endDate == null) {
    return true;
  }
  var currentDate = new Date();
  startDate = startDate && new Date(startDate);
  endDate = endDate && new Date(endDate);
  var showTile = currentDate >= startDate && currentDate <= endDate;
  return showTile;
};

/** Funtion to accept the promotion Object and return Object or empty
 * parameters Object
 * returns - Object
 */
export var filterPromoData = function filterPromoData(item) {
  var istrue = showPromoTile(item.promotionStart, item.promotionEnd);
  return istrue ? item : null;
};
/** Function to get value from an object
 * obj : object
 * key : string
 * match : string
 * value : object
 * returns - style string
 */
export var contains = function contains(obj, key, match, value) {
  if (obj) {
    for (var i = 0; i < obj.length; i++) {
      if (obj[i][key] === match) return obj[i][value];
    }
  }
  return false;
};

/** Function to check if URL is valid SVG URL
 * url : string
 * returns - boolean flag
 */
export var isSvgUrlValid = function isSvgUrlValid(url) {
  return url.match(/\.(svg)$/) != null;
};
var BG_STYLE = {
  PALETTE: 'palette',
  TEXTURE: 'texture',
  IMAGE: 'image',
  COLOR: 'color',
  VARIABLE: 'variable'
};
var colorVariableMap = {
  'Surface': '--g-color-surface',
  'Surface Dim': '--g-color-surface-dim',
  'Surface Bright': '--g-color-surface-bright',
  'Inverse Surface': '--g-color-inverse-surface',
  'Primary Container': '--g-color-primary-container',
  'Secondary Container': '--g-color-secondary-container',
  'Tertiary Container': '--g-color-tertiary-container'
};

/**
 * @return {Object} {css, type, value}
 */
export function getOverrideBackground(_ref2) {
  var entry = _ref2.entry,
    bgImage = _ref2.bgImage,
    bgColor = _ref2.bgColor,
    themeBgColor = _ref2.themeBgColor,
    colorPalette = _ref2.colorPalette;
  var backgroundId = (entry === null || entry === void 0 ? void 0 : entry.backgroundId) || '';
  var colorPaletteValue = contains(colorPalette, 'key', backgroundId, 'value');
  var textureValue = contains(textures, 'key', backgroundId, 'style');
  var colorVariable = colorVariableMap[entry === null || entry === void 0 ? void 0 : entry.colorVariable];
  bgColor = bgColor || (entry === null || entry === void 0 ? void 0 : entry.colorBackground) || themeBgColor;
  var css;
  var type;
  var value;
  // 1. Background Key palette
  if (colorPaletteValue) {
    css = "background-color: ".concat(colorPaletteValue);
    type = BG_STYLE.PALETTE;
    value = colorPaletteValue;
  }
  // 2. Background Key texture
  else if (textureValue) {
    css = textureValue;
    type = BG_STYLE.TEXTURE;
    value = textureValue;
  }

  // 3. Image Background
  else if (bgImage || entry !== null && entry !== void 0 && entry.imageBackgroundEntry || entry !== null && entry !== void 0 && entry.imageBackground) {
    var _bgImage$image, _entry$imageBackgroun, _entry$imageBackgroun2, _entry$imageBackgroun3, _bgImage$mobileImage, _entry$imageBackgroun4, _entry$imageBackgroun5, _entry$imageBackgroun6;
    var backgroundImageURLs = {
      desktopImage: (bgImage === null || bgImage === void 0 ? void 0 : (_bgImage$image = bgImage.image) === null || _bgImage$image === void 0 ? void 0 : _bgImage$image.url) || (entry === null || entry === void 0 ? void 0 : (_entry$imageBackgroun = entry.imageBackgroundEntry) === null || _entry$imageBackgroun === void 0 ? void 0 : (_entry$imageBackgroun2 = _entry$imageBackgroun.image) === null || _entry$imageBackgroun2 === void 0 ? void 0 : _entry$imageBackgroun2.url) || (entry === null || entry === void 0 ? void 0 : (_entry$imageBackgroun3 = entry.imageBackground) === null || _entry$imageBackgroun3 === void 0 ? void 0 : _entry$imageBackgroun3.url),
      mobileImage: (bgImage === null || bgImage === void 0 ? void 0 : (_bgImage$mobileImage = bgImage.mobileImage) === null || _bgImage$mobileImage === void 0 ? void 0 : _bgImage$mobileImage.url) || (entry === null || entry === void 0 ? void 0 : (_entry$imageBackgroun4 = entry.imageBackgroundEntry) === null || _entry$imageBackgroun4 === void 0 ? void 0 : (_entry$imageBackgroun5 = _entry$imageBackgroun4.mobileImage) === null || _entry$imageBackgroun5 === void 0 ? void 0 : _entry$imageBackgroun5.url) || (entry === null || entry === void 0 ? void 0 : (_entry$imageBackgroun6 = entry.imageBackground) === null || _entry$imageBackgroun6 === void 0 ? void 0 : _entry$imageBackgroun6.url)
    };
    var mobileImage = "".concat(backgroundImageURLs.mobileImage, "?").concat(imageOptimisation.params);
    var desktopImage = "".concat(backgroundImageURLs.desktopImage, "?").concat(imageOptimisation.params);
    css = "\n      background-image: url(".concat(mobileImage, ");\n      ").concat(bgColor ? "background-color: ".concat(bgColor, ";") : '', "\n      @media (min-width: ").concat(breakPoints.desktop, ") {\n        background-image: url(").concat(desktopImage, ");\n        ").concat(bgColor ? "background-color: ".concat(bgColor, ";") : '', "\n        ").concat(bgColor ? "background-size: cover;" : '', "\n      }\n    ");
    type = BG_STYLE.IMAGE;
    value = mobileImage;
  }

  // 4. Color Variable
  else if (colorVariable) {
    css = "background-color: var(--sc-utility--bg-color, hsl(var(".concat(colorVariable, ")));");
    type = BG_STYLE.VARIABLE;
    value = colorVariable;
  }

  // 5. Color Background
  else if (bgColor) {
    css = "background-color: var(--sc-utility--bg-color, ".concat(bgColor, ")");
    type = BG_STYLE.COLOR;
    value = bgColor;
  }
  return {
    css: css,
    type: type,
    value: value
  };
}

/** Function to background style of the component
 * overrideId : string
 * backgroundImageUrl : string
 * backgroundColor : string
 * colorPalette : object
 * texture : object
 * returns - style string
 */
export var getBackgroundStyle = function getBackgroundStyle(overrideId, backgroundImageUrls, backgroundColor, colorPalette, texture, isStriped, gallerybackgroundSize) {
  var style = '';
  if (colorPalette && Object.keys(colorPalette).length > 0) {
    var colorValue = contains(colorPalette, 'key', overrideId, 'value');
    var textureValue = contains(texture, 'key', overrideId, 'style');
    if (colorValue) {
      return "background-color: ".concat(colorValue);
    } else if (textureValue) {
      return textureValue;
    } else if (backgroundImageUrls) {
      var mobileImage = "".concat(backgroundImageUrls.mobileImage, "?").concat(imageOptimisation.params);
      var desktopImage = "".concat(backgroundImageUrls.desktopImage, "?").concat(imageOptimisation.params);
      if (backgroundColor) {
        return "\n        background-image: url(".concat(mobileImage, ");\n        background-color: ").concat(backgroundColor, ";\n        @media (min-width: ").concat(breakPoints.desktop, ") {\n          background-image: url(").concat(desktopImage, ");\n          background-color: ").concat(backgroundColor, ";\n          background-size: cover;\n        }\n      ");
      } else {
        return "\n        background-image: url(".concat(mobileImage, ");\n        @media (min-width: ").concat(breakPoints.desktop, ") {\n          background-image: url(").concat(desktopImage, ");\n        }\n      ");
      }
    } else if (backgroundColor) {
      if (isStriped) {
        return "background-image: ".concat(backgroundColor, "\n        background-size: ").concat(gallerybackgroundSize, "\n        ");
      } else {
        return "background-color: var(--sc-utility--bg-color, ".concat(backgroundColor, ")");
      }
    }
  }
  return style;
};

/** Function to trigger a window resize event
 * Not using window.dispatchEvent as not supported in IE
 */
export var triggerWindowResize = function triggerWindowResize() {
  if (typeof window !== 'undefined') {
    var resizeEvent = new CustomEvent('resize');
    window.dispatchEvent(resizeEvent);
  }
};

/* function to get the width of the scrollbar, if present */
export var getScrollbarWidth = function getScrollbarWidth() {
  return typeof window !== "undefined" && typeof window.document.body !== "undefined" && window.innerWidth - window.document.body.clientWidth;
};

/** Funtion to get source sets with/without WebP
 * parameters : mobileImageUrl - mobile specific url
 * desktopImageUrl: desktop specific url
 * compConfig: size config
 * imageOptimisationParam: image optimisation param
 * useWebP:  flag to use webp for srcset, defaults to false
 * returns - source set object for different viewports
 */
var getSourceSets = function getSourceSets(mobileImageUrl, desktopImageUrl, compConfig, imageOptimisationParam) {
  var _compConfig$imageRend, _compConfig$imageRend2, _compConfig$imageRend3, _compConfig$imageRend4, _compConfig$imageRend5, _compConfig$imageRend6, _compConfig$imageRend7, _compConfig$imageRend8, _compConfig$imageRend9, _compConfig$imageRend10, _compConfig$imageRend11, _compConfig$imageRend12, _compConfig$imageRend13, _compConfig$imageRend14, _compConfig$imageRend15, _compConfig$imageRend16, _compConfig$imageRend17, _compConfig$imageRend18, _compConfig$imageRend19, _compConfig$imageRend20, _compConfig$imageRend21, _compConfig$imageRend22, _compConfig$imageRend23, _compConfig$imageRend24, _compConfig$imageRend25, _compConfig$imageRend26, _compConfig$imageRend27, _compConfig$imageRend28, _compConfig$imageRend29, _compConfig$imageRend30, _compConfig$imageRend31, _compConfig$imageRend32, _compConfig$imageRend33, _compConfig$imageRend34, _compConfig$imageRend35, _compConfig$imageRend36, _compConfig$imageRend37, _compConfig$imageRend38, _compConfig$imageRend39, _compConfig$imageRend40, _compConfig$imageRend41, _compConfig$imageRend42, _compConfig$imageRend43, _compConfig$imageRend44, _compConfig$imageRend45, _compConfig$imageRend46, _compConfig$imageRend47, _compConfig$imageRend48;
  var imgQuality = (compConfig === null || compConfig === void 0 ? void 0 : compConfig.quality) || 72;
  var imageSrcSet = {};
  imageSrcSet.mobile = "".concat(mobileImageUrl, "?").concat(imageOptimisationParam, "&h=").concat(compConfig !== null && compConfig !== void 0 && (_compConfig$imageRend = compConfig.imageRenditions) !== null && _compConfig$imageRend !== void 0 && (_compConfig$imageRend2 = _compConfig$imageRend.mobile) !== null && _compConfig$imageRend2 !== void 0 && _compConfig$imageRend2.h ? compConfig.imageRenditions.mobile.h : '', "&w=").concat(compConfig !== null && compConfig !== void 0 && (_compConfig$imageRend3 = compConfig.imageRenditions) !== null && _compConfig$imageRend3 !== void 0 && (_compConfig$imageRend4 = _compConfig$imageRend3.mobile) !== null && _compConfig$imageRend4 !== void 0 && _compConfig$imageRend4.w ? compConfig === null || compConfig === void 0 ? void 0 : (_compConfig$imageRend5 = compConfig.imageRenditions) === null || _compConfig$imageRend5 === void 0 ? void 0 : (_compConfig$imageRend6 = _compConfig$imageRend5.mobile) === null || _compConfig$imageRend6 === void 0 ? void 0 : _compConfig$imageRend6.w : '', "&q=").concat(imgQuality);
  imageSrcSet.mobileRetina = "".concat(mobileImageUrl, "?").concat(imageOptimisationParam, "&h=").concat(compConfig !== null && compConfig !== void 0 && (_compConfig$imageRend7 = compConfig.imageRenditions) !== null && _compConfig$imageRend7 !== void 0 && (_compConfig$imageRend8 = _compConfig$imageRend7.mobile) !== null && _compConfig$imageRend8 !== void 0 && _compConfig$imageRend8.h ? (compConfig === null || compConfig === void 0 ? void 0 : (_compConfig$imageRend9 = compConfig.imageRenditions) === null || _compConfig$imageRend9 === void 0 ? void 0 : (_compConfig$imageRend10 = _compConfig$imageRend9.mobile) === null || _compConfig$imageRend10 === void 0 ? void 0 : _compConfig$imageRend10.h) * 2 : '', "&w=").concat(compConfig !== null && compConfig !== void 0 && (_compConfig$imageRend11 = compConfig.imageRenditions) !== null && _compConfig$imageRend11 !== void 0 && (_compConfig$imageRend12 = _compConfig$imageRend11.mobile) !== null && _compConfig$imageRend12 !== void 0 && _compConfig$imageRend12.w ? (compConfig === null || compConfig === void 0 ? void 0 : (_compConfig$imageRend13 = compConfig.imageRenditions) === null || _compConfig$imageRend13 === void 0 ? void 0 : (_compConfig$imageRend14 = _compConfig$imageRend13.mobile) === null || _compConfig$imageRend14 === void 0 ? void 0 : _compConfig$imageRend14.w) * 2 : '', "&q=").concat(imgQuality);
  // imageSrcSet.mobileSm = `${mobileImageUrl}?${imageOptimisationParam}&h=${
  //   compConfig?.imageRenditions?.mobileSm?.h
  //     ? compConfig.imageRenditions.mobileSm.h
  //     : ''
  // }&w=${
  //   compConfig?.imageRenditions?.mobileSm?.w
  //     ? compConfig?.imageRenditions?.mobileSm?.w
  //     : ''
  // }&q=${imgQuality}`;

  // imageSrcSet.mobileRetina = `${mobileImageUrl}?${imageOptimisationParam}&h=${
  //   compConfig?.imageRenditions?.mobileSm?.h
  //     ? compConfig?.imageRenditions?.mobileSm?.h * 2
  //     : ''
  // }&w=${
  //   compConfig?.imageRenditions?.mobile?.w
  //     ? compConfig?.imageRenditions?.mobile?.w * 2
  //     : ''
  // }&q=${imgQuality}`;

  imageSrcSet.tabletP = "".concat(mobileImageUrl, "?").concat(imageOptimisationParam, "&h=").concat(compConfig !== null && compConfig !== void 0 && (_compConfig$imageRend15 = compConfig.imageRenditions) !== null && _compConfig$imageRend15 !== void 0 && (_compConfig$imageRend16 = _compConfig$imageRend15.tabletP) !== null && _compConfig$imageRend16 !== void 0 && _compConfig$imageRend16.h ? compConfig === null || compConfig === void 0 ? void 0 : (_compConfig$imageRend17 = compConfig.imageRenditions) === null || _compConfig$imageRend17 === void 0 ? void 0 : (_compConfig$imageRend18 = _compConfig$imageRend17.tabletP) === null || _compConfig$imageRend18 === void 0 ? void 0 : _compConfig$imageRend18.h : '', "&w=").concat(compConfig !== null && compConfig !== void 0 && (_compConfig$imageRend19 = compConfig.imageRenditions) !== null && _compConfig$imageRend19 !== void 0 && (_compConfig$imageRend20 = _compConfig$imageRend19.tabletP) !== null && _compConfig$imageRend20 !== void 0 && _compConfig$imageRend20.w ? compConfig.imageRenditions.tabletP.w : '', "&q=").concat(imgQuality);
  imageSrcSet.tabletPRetina = "".concat(mobileImageUrl, "?").concat(imageOptimisationParam, "&h=").concat(compConfig !== null && compConfig !== void 0 && (_compConfig$imageRend21 = compConfig.imageRenditions) !== null && _compConfig$imageRend21 !== void 0 && (_compConfig$imageRend22 = _compConfig$imageRend21.tabletP) !== null && _compConfig$imageRend22 !== void 0 && _compConfig$imageRend22.h ? compConfig.imageRenditions.tabletP.h * 2 : '', "&w=").concat(compConfig !== null && compConfig !== void 0 && (_compConfig$imageRend23 = compConfig.imageRenditions) !== null && _compConfig$imageRend23 !== void 0 && (_compConfig$imageRend24 = _compConfig$imageRend23.tabletP) !== null && _compConfig$imageRend24 !== void 0 && _compConfig$imageRend24.w ? compConfig.imageRenditions.tabletP.w * 2 : '', "&q=").concat(imgQuality);
  imageSrcSet.tabletL = "".concat(desktopImageUrl, "?").concat(imageOptimisationParam, "&h=").concat(compConfig !== null && compConfig !== void 0 && (_compConfig$imageRend25 = compConfig.imageRenditions) !== null && _compConfig$imageRend25 !== void 0 && (_compConfig$imageRend26 = _compConfig$imageRend25.tabletL) !== null && _compConfig$imageRend26 !== void 0 && _compConfig$imageRend26.h ? compConfig.imageRenditions.tabletL.h : '', "&w=").concat(compConfig !== null && compConfig !== void 0 && (_compConfig$imageRend27 = compConfig.imageRenditions) !== null && _compConfig$imageRend27 !== void 0 && (_compConfig$imageRend28 = _compConfig$imageRend27.tabletL) !== null && _compConfig$imageRend28 !== void 0 && _compConfig$imageRend28.w ? compConfig.imageRenditions.tabletL.w : '', "&q=").concat(imgQuality);
  imageSrcSet.tabletLRetina = "".concat(desktopImageUrl, "?").concat(imageOptimisationParam, "&h=").concat(compConfig !== null && compConfig !== void 0 && (_compConfig$imageRend29 = compConfig.imageRenditions) !== null && _compConfig$imageRend29 !== void 0 && (_compConfig$imageRend30 = _compConfig$imageRend29.tabletL) !== null && _compConfig$imageRend30 !== void 0 && _compConfig$imageRend30.h ? compConfig.imageRenditions.tabletL.h * 2 : '', "&w=").concat(compConfig !== null && compConfig !== void 0 && (_compConfig$imageRend31 = compConfig.imageRenditions) !== null && _compConfig$imageRend31 !== void 0 && (_compConfig$imageRend32 = _compConfig$imageRend31.tabletL) !== null && _compConfig$imageRend32 !== void 0 && _compConfig$imageRend32.w ? compConfig.imageRenditions.tabletL.w * 2 : '', "&q=").concat(imgQuality);
  imageSrcSet.desktop = "".concat(desktopImageUrl, "?").concat(imageOptimisationParam, "&h=").concat(compConfig !== null && compConfig !== void 0 && (_compConfig$imageRend33 = compConfig.imageRenditions) !== null && _compConfig$imageRend33 !== void 0 && (_compConfig$imageRend34 = _compConfig$imageRend33.desktop) !== null && _compConfig$imageRend34 !== void 0 && _compConfig$imageRend34.h ? compConfig.imageRenditions.desktop.h : '', "&w=").concat(compConfig !== null && compConfig !== void 0 && (_compConfig$imageRend35 = compConfig.imageRenditions) !== null && _compConfig$imageRend35 !== void 0 && (_compConfig$imageRend36 = _compConfig$imageRend35.desktop) !== null && _compConfig$imageRend36 !== void 0 && _compConfig$imageRend36.w ? compConfig.imageRenditions.desktop.w : '', "&q=").concat(imgQuality);
  imageSrcSet.desktopRetina = "".concat(desktopImageUrl, "?").concat(imageOptimisationParam, "&h=").concat(compConfig !== null && compConfig !== void 0 && (_compConfig$imageRend37 = compConfig.imageRenditions) !== null && _compConfig$imageRend37 !== void 0 && (_compConfig$imageRend38 = _compConfig$imageRend37.desktop) !== null && _compConfig$imageRend38 !== void 0 && _compConfig$imageRend38.h ? compConfig.imageRenditions.desktop.h * 2 : '', "&w=").concat(compConfig !== null && compConfig !== void 0 && (_compConfig$imageRend39 = compConfig.imageRenditions) !== null && _compConfig$imageRend39 !== void 0 && (_compConfig$imageRend40 = _compConfig$imageRend39.desktop) !== null && _compConfig$imageRend40 !== void 0 && _compConfig$imageRend40.w ? compConfig.imageRenditions.desktop.w * 2 : '', "&q=").concat(imgQuality);
  imageSrcSet.desktopL = "".concat(desktopImageUrl, "?").concat(imageOptimisationParam, "&h=").concat(compConfig !== null && compConfig !== void 0 && (_compConfig$imageRend41 = compConfig.imageRenditions) !== null && _compConfig$imageRend41 !== void 0 && (_compConfig$imageRend42 = _compConfig$imageRend41.desktopL) !== null && _compConfig$imageRend42 !== void 0 && _compConfig$imageRend42.h ? compConfig.imageRenditions.desktopL.h : '', "&w=").concat(compConfig !== null && compConfig !== void 0 && (_compConfig$imageRend43 = compConfig.imageRenditions) !== null && _compConfig$imageRend43 !== void 0 && (_compConfig$imageRend44 = _compConfig$imageRend43.desktopL) !== null && _compConfig$imageRend44 !== void 0 && _compConfig$imageRend44.w ? compConfig.imageRenditions.desktopL.w : '', "&q=").concat(imgQuality);
  imageSrcSet.desktopLRetina = "".concat(desktopImageUrl, "?").concat(imageOptimisationParam, "&h=").concat(compConfig !== null && compConfig !== void 0 && (_compConfig$imageRend45 = compConfig.imageRenditions) !== null && _compConfig$imageRend45 !== void 0 && (_compConfig$imageRend46 = _compConfig$imageRend45.desktopL) !== null && _compConfig$imageRend46 !== void 0 && _compConfig$imageRend46.h ? compConfig.imageRenditions.desktopL.h * 2 : '', "&w=").concat(compConfig !== null && compConfig !== void 0 && (_compConfig$imageRend47 = compConfig.imageRenditions) !== null && _compConfig$imageRend47 !== void 0 && (_compConfig$imageRend48 = _compConfig$imageRend47.desktopL) !== null && _compConfig$imageRend48 !== void 0 && _compConfig$imageRend48.w ? compConfig.imageRenditions.desktopL.w * 2 : '', "&q=").concat(imgQuality);
  return imageSrcSet;
};

/** Function to return image srset in viewports
 * parameters : mobileImageUrl - mobile specific url
 * desktopImageUrl: desktop specific url
 * compConfig: size config
 * imageOptimisationParam: image optimisation param
 * returns - source set object for different viewports
 */
export var getImageSrcSet = function getImageSrcSet(compConfig, desktopImageUrl, mobileImageUrl, imageOptimisationType) {
  if (!mobileImageUrl) {
    mobileImageUrl = desktopImageUrl;
  }
  var imageSrcSet = {};
  var imageOptimisationParam = imageOptimisationType ? imageOptimisation[imageOptimisationType] : imageOptimisation.params;
  imageSrcSet = getSourceSets(mobileImageUrl, desktopImageUrl, compConfig, imageOptimisationParam);
  return imageSrcSet;
};
/**
 * Determine If A Color Is Bright Or Dark Using JavaScript
 * @input hex rgb color
 * return dark light
 */

export var isColorLightOrDark = function isColorLightOrDark(color) {
  var _color;
  // Variables for red, green, blue values
  var r, g, b, hsp;

  // Check the format of the color, HEX or RGB?
  if ((_color = color) !== null && _color !== void 0 && _color.match(/^rgb/)) {
    // If HEX --> store the red, green, blue values in separate variables
    color = color.match(/^rgba?\((\d+),\s*(\d+),\s*(\d+)(?:,\s*(\d+(?:\.\d+)?))?\)$/);
    r = color[1];
    g = color[2];
    b = color[3];
  } else {
    var _color2;
    // If RGB --> Convert it to HEX: http://gist.github.com/983661
    color = +('0x' + ((_color2 = color) === null || _color2 === void 0 ? void 0 : _color2.slice(1).replace(color.length < 5 && /./g, '$&$&')));
    r = color >> 16;
    g = color >> 8 & 255;
    b = color & 255;
  }

  // HSP (Highly Sensitive Poo) equation from http://alienryderflex.com/hsp.html
  hsp = Math.sqrt(0.299 * (r * r) + 0.587 * (g * g) + 0.114 * (b * b));

  // Using the HSP value, determine whether the color is light or dark
  if (hsp > 127.5) {
    return THEME_CONST.LIGHT;
  } else {
    return THEME_CONST.DARK;
  }
};

/**
 * @param {Object} background - background styles object
 * @param {string} background.css - CSS string for background styles
 * @param {string} background.type - type of background style (e.g., 'color', 'texture', etc.)
 * @param {string} background.value - color value for the background
 */
export var isBgColorStyleLight = function isBgColorStyleLight() {
  var _setColor;
  var background = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
  var _useContext = useContext(Context),
    dynamicStylesColors = _useContext.dynamicStylesColors;
  var setColor;
  // When using textures
  if (background !== null && background !== void 0 && background.css && Array.isArray(background === null || background === void 0 ? void 0 : background.css)) {
    var _background$css, _background$css$;
    var pattern = /(background-color:\s?#)([a-f0-9]{3}|[a-f0-9]{6})\b|(background-color:\s?rgb)a?\([^)]*\)/gi;
    setColor = (_background$css = background.css) === null || _background$css === void 0 ? void 0 : (_background$css$ = _background$css[0]) === null || _background$css$ === void 0 ? void 0 : _background$css$.match(pattern);
    setColor = setColor[0].split(':')[1];
  } else {
    var _background$css2;
    setColor = (_background$css2 = background.css) === null || _background$css2 === void 0 ? void 0 : _background$css2.replace('background-color:', '').trim();
  }
  if ((_setColor = setColor) !== null && _setColor !== void 0 && _setColor.match(/var\(--sc-utility--bg-color,/gi)) {
    setColor = setColor.replace('var(--sc-utility--bg-color,', '').replace(')', '').trim();
  }
  if ((background === null || background === void 0 ? void 0 : background.type) === BG_STYLE.VARIABLE) {
    try {
      setColor = convertToRgba("hsl(".concat(dynamicStylesColors[background.value], ")"));
    } catch (error) {
      console.error('Error converting color variable from Override Background:', error);
    }
  }
  return isColorLightOrDark(setColor) === THEME_CONST.LIGHT;
};
export var getContrastColorVariable = function getContrastColorVariable(background, fallbackColor) {
  if ((background === null || background === void 0 ? void 0 : background.type) !== BG_STYLE.VARIABLE) return fallbackColor;
  return "hsl(var(".concat(background.value, "-contrast, ").concat(fallbackColor, "))");
};

/**
 * Set non-cta anchor styling
 */

export var setNonCtaAnchorStyling = function setNonCtaAnchorStyling(theme, background) {
  return "\n    color: ".concat(background ? getContrastColorVariable(background, theme === null || theme === void 0 ? void 0 : theme.textColorLight) : theme === null || theme === void 0 ? void 0 : theme.textColorLight, ";\n    text-decoration: underline;");
};
export var undoSettingOfNonCtaAnchorStyling = function undoSettingOfNonCtaAnchorStyling(anchorColor, background) {
  return "color: ".concat(background ? getContrastColorVariable(background, anchorColor) : anchorColor, ";\n    text-decoration: none;\n    &:hover {\n      text-decoration: underline;\n    }");
};

/**
 * the function below handles the situation where the CTA has a
 * transparent background and the background of the parent is dark
 */

export var replacePrimaryAnchorWithLightPrimaryAnchor = function replacePrimaryAnchorWithLightPrimaryAnchor(themeButton) {
  return "color: ".concat(themeButton.linkColorLightPrimary ? "var(--sc-button--color-link-light-primary, ".concat(themeButton.linkColorLightPrimary, ")") : '', ";\nbackground-color: ").concat(themeButton.backgroundColorLightPrimary ? "var(--sc-button--bg-color-light-primary, ".concat(themeButton.backgroundColorLightPrimary, ")") : '', ";\nborder-radius: ").concat(themeButton.borderRadiusLightPrimary ? "var(--sc-button--border-radius-light-primary, ".concat(themeButton.borderRadiusLightPrimary, ")") : '', ";\nborder-color: ").concat(themeButton.borderColorLightPrimary ? "var(--sc-button--border-color-light-primary, ".concat(themeButton.borderColorLightPrimary, ")") : '', ";\n&:hover {\ncolor: ").concat(themeButton.linkColorLightPrimaryHover ? "var(--sc-button--color-link-light-primary-hover, ".concat(themeButton.linkColorLightPrimaryHover, ")") : '', ";\nbackground-color: ").concat(themeButton.backgroundColorHoverLightPrimary ? "var(--sc-button--bg-color-light-primary-hover, ".concat(themeButton.backgroundColorHoverLightPrimary, ")") : '', ";\nborder-color: ").concat(themeButton.borderColorLightPrimaryHover ? "var(--sc-button--border-color-light-primary-hover, ".concat(themeButton.borderColorLightPrimaryHover, ")") : '', ";}");
};
export var replaceSecondaryAnchorWithAltSecondaryAnchor = function replaceSecondaryAnchorWithAltSecondaryAnchor(themeButton) {
  var underline = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : false;
  var underlineOnHover = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : false;
  return "color: ".concat(themeButton.linkColorAltSecondary ? "var(--sc-button--color-link-alt-secondary, ".concat(themeButton.linkColorAltSecondary, ")") : '', ";\nbackground-color: ").concat(themeButton.backgroundColorAltSecondary ? "var(--sc-button--bg-color-alt-secondary, ".concat(themeButton.backgroundColorAltSecondary, ")") : '', ";\nborder-radius: ").concat(themeButton.borderRadiusAltSecondary ? "var(--sc-button--border-radius-alt-secondary, ".concat(themeButton.borderRadiusAltSecondary, ")") : '', ";\nborder-color: ").concat(themeButton.borderColorAltSecondary ? "var(--sc-button--border-color-alt-secondary, ".concat(themeButton.borderColorAltSecondary, ")") : '', ";\n  text-decoration: ").concat(underline ? 'underline' : 'none', ";\n&:hover {\n  text-decoration: ").concat(underlineOnHover ? 'underline' : 'none', ";\ncolor: ").concat(themeButton.linkColorAltSecondaryHover ? "var(--sc-button--color-link-alt-secondary-hover, ".concat(themeButton.linkColorAltSecondaryHover, ")") : '', ";\nbackground-color: ").concat(themeButton.backgroundColorHoverAltSecondary ? "var(--sc-button--bg-color-alt-secondary-hover, ".concat(themeButton.backgroundColorHoverAltSecondary, ")") : '', ";\nborder-color: ").concat(themeButton.borderColorAltSecondaryHover ? "var(--sc-button--border-color-alt-secondary-hover, ".concat(themeButton.backgroundColorHoverAltSecondary, ")") : '', ";}");
};

/**
 * @function isBrowser
 * Determines whether or not the document, body, & window are available
 * @returns {boolean}
 */

var isBrowser = function isBrowser() {
  return typeof document !== 'undefined' && typeof window !== 'undefined' && document.body;
};

/**
 * @function scrollPageTo
 * scrolls the page to (x, y)
 */
export var scrollPageTo = function scrollPageTo(selector) {
  if (isBrowser()) {
    var el = document.querySelector(selector);
    if (el) {
      var offsetTop = el.offsetTop;
      try {
        window.scrollTo({
          top: offsetTop,
          behavior: 'smooth'
        });
      } catch (e) {
        // IE accepts only (x,y) not an object
        window.scrollTo(0, offsetTop);
      }
    }
  }
};

/**
 * Get elements height by selector.
 * @param {string} selector Elements css selector.
 * @return {number} height of element.
 */
export var getElementHeight = function getElementHeight(selector) {
  if (isBrowser()) {
    var el = document.querySelector(selector);
    return el ? el.clientHeight : null;
  }
};

/**
 * Get document height
 */
export var getDocumentHeight = function getDocumentHeight() {
  if (isBrowser()) {
    return Math.max(document.body.scrollHeight, document.body.offsetHeight, document.documentElement.clientHeight, document.documentElement.scrollHeight, document.documentElement.offsetHeight);
  }
};
export var getIOSVersion = function getIOSVersion() {
  var version;
  if (typeof navigator !== 'undefined' && navigator.platform) {
    if (/iP(hone|od|ad)/.test(navigator.platform)) {
      var v = navigator.appVersion.match(/OS (\d+)_(\d+)_?(\d+)?/);
      version = [parseInt(v[1], 10), parseInt(v[2], 10), parseInt(v[3] || 0, 10)];
    }
  }
  return version;
};

/**
 * Function to get
 * @param themeBgColor
 * @param themePalette
 * @param overrideBackground
 * @param asStyle
 * @return {string|boolean|string}
 */
export var getOverrideBackgroundColor = function getOverrideBackgroundColor(themeBgColor, themePalette, overrideBackground) {
  var asStyle = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : false;
  var backgroundColor = overrideBackground && overrideBackground.colorBackground ? overrideBackground.colorBackground : themeBgColor;
  if (!asStyle) {
    return backgroundColor;
  }
  var backgroundImageURLs = overrideBackground && overrideBackground.imageBackground ? {
    desktopImage: overrideBackground.imageBackground && overrideBackground.imageBackground.url,
    mobileImage: overrideBackground.imageBackground && overrideBackground.imageBackground.url
  } : '';
  return getBackgroundStyle(overrideBackground ? overrideBackground.backgroundId : '', backgroundImageURLs, backgroundColor, themePalette, textures);
};

/**
 * Function to get text color style for footer.
 *
 * @return {string|boolean|string}
 * @param customFontColor
 * @param footerTheme
 * @param defaultColor
 */
export var getFooterTextColorStyle = function getFooterTextColorStyle(customFontColor, footerTheme, defaultColor) {
  if (!customFontColor) {
    return defaultColor;
  }
  if (customFontColor === fontColor.light) {
    return "var(--sc-footer--text-color-light, ".concat(footerTheme.textColorLight, ")");
  } else if (customFontColor === fontColor.dark) {
    return "var(--sc-footer--text-color-dark, ".concat(footerTheme.textColorDark, ")");
  } else {
    return defaultColor;
  }
};
export var pencilUrlParseSitePage = function pencilUrlParseSitePage(sitePencilBanner, path) {
  path = path == '/undefined' ? '/' : "/".concat(path);
  if (sitePencilBanner && path) {
    var avoidPaths = sitePencilBanner.notDisplayOn;
    if (avoidPaths && Array.isArray(avoidPaths) && avoidPaths.length > 0) {
      return avoidPaths.includes(path);
    } else {
      return false;
    }
  }
  return true;
};
export var pencilUrlParseSite = function pencilUrlParseSite(avoidPaths, pagePath) {
  return avoidPaths && pagePath && Array.isArray(avoidPaths) && avoidPaths.length > 0 && avoidPaths.includes(pagePath);
};

/**
 * Extract twitter userName of url.
 * @param {string} url .
 * @return {string} @userName.
 */
export var extractTwitterHandle = function extractTwitterHandle(url) {
  var _match$groups;
  if (!url) return null;
  var match = url.match( /*#__PURE__*/_wrapRegExp(/^https?:\/\/(www\.)?twitter.com\/@?(\w+)/, {
    handle: 2
  }));
  return match !== null && match !== void 0 && (_match$groups = match.groups) !== null && _match$groups !== void 0 && _match$groups.handle ? "@".concat(match.groups.handle) : null;
};
export var getBrowserName = function getBrowserName() {
  var userAgent = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : navigator.userAgent;
  // The order matters here, and this may report false positives for unlisted browsers.

  if (userAgent.includes("Firefox")) {
    // "Mozilla/5.0 (X11; Linux i686; rv:104.0) Gecko/20100101 Firefox/104.0"
    return BROWSER.FIREFOX;
  } else if (userAgent.includes("SamsungBrowser")) {
    // "Mozilla/5.0 (Linux; Android 9; SAMSUNG SM-G955F Build/PPR1.180610.011) AppleWebKit/537.36 (KHTML, like Gecko) SamsungBrowser/9.4 Chrome/67.0.3396.87 Mobile Safari/537.36"
    return BROWSER.SAMSUNG;
  } else if (userAgent.includes("Opera") || userAgent.includes("OPR")) {
    // "Mozilla/5.0 (Macintosh; Intel Mac OS X 12_5_1) AppleWebKit/537.36 (KHTML, like Gecko) Chrome/104.0.0.0 Safari/537.36 OPR/90.0.4480.54"
    return BROWSER.OPERA;
  } else if (userAgent.includes("Edge")) {
    // "Mozilla/5.0 (Windows NT 10.0; Win64; x64) AppleWebKit/537.36 (KHTML, like Gecko) Chrome/58.0.3029.110 Safari/537.36 Edge/16.16299"
    return BROWSER.EDGE_LEGACY;
  } else if (userAgent.includes("Edg")) {
    // "Mozilla/5.0 (Windows NT 10.0; Win64; x64) AppleWebKit/537.36 (KHTML, like Gecko) Chrome/104.0.0.0 Safari/537.36 Edg/104.0.1293.70"
    return BROWSER.EDGE;
  } else if (userAgent.includes("Chrome")) {
    // "Mozilla/5.0 (X11; Linux x86_64) AppleWebKit/537.36 (KHTML, like Gecko) Chrome/104.0.0.0 Safari/537.36"
    return BROWSER.CHROME;
  } else if (userAgent.includes("Safari")) {
    // "Mozilla/5.0 (iPhone; CPU iPhone OS 15_6_1 like Mac OS X) AppleWebKit/605.1.15 (KHTML, like Gecko) Version/15.6 Mobile/15E148 Safari/604.1"
    return BROWSER.SAFARI;
  } else {
    return "unknown";
  }
};